<template>
  <div>
    <shipblu-prompt
      class="shipment-modal"
      @close="closeModal"
      :active.sync="addMerchantInfo"
      title=""
      :buttons-hidden="true">
      <p class="text-xl font-semibold mb-1">{{$t('Welcome')}} {{userMerchant.first_name}} </p>
      <p class="text-md font-medium mb-4">{{$t('Complete your profile to start shipping your first order')}}</p>
      <div class="mb-4">
        <p class="text-lg font-semibold mb-2">
          {{$t('Your Company Name "will be displayed on the shipping label"')}}
        </p>
        <vs-input v-validate="'required|max:20'" name="company name" :placeholder="$t('Company Name')" v-model="merchant.name" class="w-full"/>
        <span class="text-danger text-sm" v-show="errors.has('company name')">{{$t('The company name field is required')}}</span>
      </div>
      <div class="mb-4">
        <p class="text-lg font-semibold mb-2">
          {{$t('Your Location')}}
        </p>
        <p class="font-medium text-sm text-grey-dark mb-2">{{$t('Address Line 1')}}</p>
        <div class="mb-4">
          <vs-input v-validate="'required'" name="address 1" :placeholder="$t('Address 1')" v-model="merchant.address.line_1" class="w-full"/>
          <span class="text-danger text-sm" v-show="errors.has('address 1')">{{$t('The address 1 field is required')}}</span>
        </div>
        <div class="mb-4">
          <vs-input v-validate="'required'" name="address 2" :placeholder="$t('Address 2')" v-model="merchant.address.line_2" class="w-full"/>
          <span class="text-danger text-sm" v-show="errors.has('address 2')">{{$t('The line 2 field is required')}}</span>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-2 mb-4">
          <div>
            <v-select v-on:input="merchant.merchant_governorate ? loadCities(`${merchant.merchant_governorate.id}`) : ''" autocomplete="nofill" class="col-span-1 address w-full" name="governorate" v-model="merchant.merchant_governorate" v-validate="'required'" :placeholder="$t('Governorate')" label="name" :options="governorates"/>
            <span class="text-danger text-sm" v-show="errors.has('governorate')">{{$t('The governorate field is required')}}</span>
          </div>
          <div>
            <v-select v-on:input="merchant.merchant_city ? loadZones(`${merchant.merchant_city.id}`) : ''" autocomplete="nofill" class="col-span-1 address w-full" name="city" v-model="merchant.merchant_city"
              v-validate="'required'" :placeholder="$t('City')" label="name" :options="cities"/>
            <span class="text-danger text-sm" v-show="errors.has('city')">{{$t('The city field is required')}}</span>
          </div>
          <div>
            <v-select autocomplete="nofill" class="col-span-1 address w-full" v-model="merchant.address.zone" v-validate="'required'"
              name="zone" :placeholder="$t('Zone')" label="name" :options="zones"/>
            <span class="text-danger text-sm" v-show="errors.has('zone') || (merchant.address.zone && merchant.address.zone.id === 284)">
              {{$t('The zone field is required')}}
            </span>
          </div>
        </div>
      </div>
      <div class="grid sm:grid-cols-2 grid-cols-1 gap-2 mb-4">
        <div class="col-span-1">
        <p class="text-lg font-semibold mb-2">
          {{$t('Monthly Shipping Volume')}}
        </p>
          <vs-input v-validate="'required|numeric'" :placeholder="$t('Committed Volume')" name="committed volume" v-model="merchant.committed_volume" class="mt-2 w-full"/>
          <span class="text-danger text-sm" v-show="errors.has('committed volume')">{{$t('The monthly shipping volume is required')}}</span>
        </div>
      </div>
      <div class= "mb-4">
        <p class="text-md font-semibold mb-2">{{$t('Website or Social Media URL')}}</p>
        <vs-input v-validate="'required|url'" name="store url" placeholder="https://www.example.com" v-model="merchant.store_url" class="w-full"/>
        <span class="text-danger text-sm" v-show="errors.has('store url')">{{$t(errors.first('store url'))}}</span>
      </div>
      <div class="mb-4">
        <div class="text-md font-semibold mb-2">
          <label class="font-semibold">{{$t('Industry')}}</label>
        </div>
        <div>
          <v-select autocomplete="nofill" class="mt-2 w-full" v-model="merchant.industry" v-validate="'required'"
            name="industry" :placeholder="$t('Industries')" label="text" :options="industries"/>
          <span class="text-danger text-sm" v-show="errors.has('industry')">{{$t('The industry field is required') }}</span>
        </div>
      </div>
      <div class="flex justify-center">
        <vs-button class="font-medium md:text-lg" @click="updateMerchant()">{{$t('Get Started')}}</vs-button>
      </div>
    </shipblu-prompt>
  </div>
</template>

<script>
import common from '../../../assets/utils/common'
import { sendRequest } from '../../../http/axios/requestHelper'
import ShipbluPrompt from '../../../layouts/components/ShipBluPrompt.vue'
import vSelect from 'vue-select'

export default {
  props: ['addMerchantInfo'],
  data () {
    return {
      userMerchant: {},
      merchant: {
        address: {
          line_3: '',
          line_1: '',
          line_2: '',
          zone: ''
        }
      },
      governorates: [],
      cities: [],
      zones: [],
      sales: common.salesChannels,
      industries: [],
      pickupPoint: {},
      returnPoint: {},
      merchantData: {}
    }
  },
  watch: {
    'addMerchantInfo' (val) {
      if (val === true) {
        this.$validator.resume()
        const merchant = common.checkMerchantInLocalStorage(this)
        merchant.then(results => {
          this.userMerchant = results.userMerchantData
          this.merchantData = results.merchantData
          this.loadGovernorates()
          this.loadPickupPoints()
          this.loadReturnPoints()
        })
      }
    },
    '$route.params.lang' () {
      this.industries = common.getIndustries(this)
    }
  },
  methods: {
    loadGovernorates () {
      const govPromise = common.loadGovernorates(this)
      govPromise.then((results) => {
        this.governorates = results.data
        this.governorates = this.governorates.filter(item => item.id === 1 || item.id === 2 || item.id === 16)
      })
    },
    loadCities (governorateID) {
      const cityPromise = common.loadCities(governorateID, this)
      cityPromise.then((results) => {
        this.cities = results.data
      })
    },
    loadZones (cityID) {
      const zonePromise = common.loadZones(cityID, this)
      zonePromise.then((results) => {
        this.zones = results.data
      })
    },
    closeModal () {
      this.$emit('selected', [])
      this.$emit('addMerchantInfo', false)
      this.merchant = {
        address: {}
      }
      this.$validator.pause()
    },
    updateMerchant () {
      this.$validator.validateAll().then(result => {
        if (result && this.merchant.address.zone && this.merchant.address.zone.id !== 284) {
          this.merchant.address.id = this.merchantData.address.id
          this.merchant.address.zone = this.merchant.address.zone.id
          this.merchant.display_name = this.merchant.name
          this.merchant.industry = this.merchant.industry.value
          sendRequest(false, false, this, `api/v1/merchants/${this.userMerchant.merchant}/?company_details=true`, 'patch', this.merchant, true,
            (response) => {
              this.updateProfileIsCompleted()
              localStorage.removeItem('merchant')
              localStorage.setItem('merchant', JSON.stringify(response.data))
            }
          )
        }
      })
    },
    updateProfileIsCompleted () {
      sendRequest(false, false, this, `api/v1/merchants/${this.userMerchant.merchant}/profile-completed/`, 'patch', {}, true,
        () => {
          this.updatePickupPoint()
        }
      )
    },
    updatePickupPoint () {
      const addressObj = {
        address: {
          id: this.pickupPoint.address.id,
          ...this.merchant.address
        }
      }
      sendRequest(false, false, this, `api/v1/merchants/${this.userMerchant.merchant}/pickup-points/${this.pickupPoint.id}/`, 'patch', addressObj, true,
        () => {
          this.updateReturnPoint()
        }
      )
    },
    updateReturnPoint () {
      const addressObj = {
        address: {
          id: this.pickupPoint.address.id,
          ...this.merchant.address
        }
      }
      sendRequest(false, false, this, `api/v1/merchants/${this.userMerchant.merchant}/return-points/${this.returnPoint.id}/`, 'patch', addressObj, true,
        () => {
          this.closeModal()
          this.$emit('merchantUpdated', true)
          this.$router.push({
            name: 'merchant-dashboard'
          }).catch(() => {})
          if (this.$route.name === 'merchant-dashboard') {
            location.reload()
          }
          this.merchant = {
            address: {
            }
          }
        }
      )
    },
    loadPickupPoints () {
      sendRequest(false, false, this, `api/v1/merchants/${this.userMerchant.merchant}/pickup-points/`, 'get', null, true,
        (response) => {
          this.pickupPoint = response.data.results[0]
        }
      )
    },
    loadReturnPoints () {
      sendRequest(false, false, this, `api/v1/merchants/${this.userMerchant.merchant}/return-points/`, 'get', null, true,
        (response) => {
          this.returnPoint = response.data.results[0]
        }
      )
    }
  },
  components: {
    ShipbluPrompt,
    vSelect
  },
  created () {
    this.industries = common.getIndustries(this)
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
.v-select {
  &.address {
    width: 100%;
    min-width: 150px;
    .vs__selected {
      width: 90px;
      white-space: nowrap;
      overflow: hidden;
    }
  }
}
.card-loader {
  position: relative;
  border-radius: 5px;
  height: 170px;
  overflow: hidden;
  &:before {
    content: '';
    height: 110px;
    display: block;
    background-color: #ededed;
    box-shadow: -48px 78px 0 -48px #ededed, -51px 102px 0 -51px #ededed;
  }
  &:after {
    content: '';
    background-color: #333;
    width: 100%;
    height: 100%;
    position: absolute;
    inset: 0;
    animation: loader-animate 1s infinite linear;
    background: -webkit-linear-gradient(left, rgba(255,255,255,0) 0%, rgba(255,255,255,0.6) 30%, rgba(255,255,255,0) 81%);
    background: -o-linear-gradient(left, rgba(255,255,255,0) 0%, rgba(255,255,255,0.6) 30%, rgba(255,255,255,0) 81%);
    background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.6) 30%, rgba(255,255,255,0) 81%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#00ffffff',GradientType=1 );
  }
}
</style>